import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Whisper, Popover } from "rsuite";
import { FaRegCalendarAlt, FaRegEdit, FaRegEye } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";

const ActionCellBranch = ({ data }) => {
  const navigate = useNavigate();  

  const location = useLocation();


  const renderPopover = (
    <Popover arrow={false} full className="p-2 rounded-md w-48">
      <div className="px-3 pt-2 pb-1 text-sm font-bold text-gray-800">
        Actions
      </div>

      <div
        onClick={() =>
            navigate("/AddBranchPharmacy")
        }
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
      >
        <FaRegEdit className="text-sm text-[#55c999]" />
        <span>Edit</span>
      </div>

      <div
        onClick={() =>
            navigate("/BranchView")
        }
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
      >
        <FaRegEye className="text-sm text-[#383838]" />
        <span>View</span>
      </div>

      {/* <div
        onClick={() => {
          navigate("/AddAppointment", {
            state: {
              showModal: true,
              patientName: data?.fullName,
              fromPatientView: true,
              patientUserUniqueID: data?.userUniqueID,
            },
          });
        }}
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
      >
        <FaRegCalendarAlt className="text-sm text-[#383838]" />
        <span>Make Appointment</span>
      </div> */}

      {/* Optional Delete / Inactive */}
      {/* <div
   
        className="flex items-center gap-2 px-3 py-2 text-sm text-red-600 cursor-pointer hover:bg-gray-100 rounded-md"
      >
        <MdDeleteOutline className="text-lg" />
        <span>Inactive</span>
      </div> */}
    </Popover>
  );

  return (
    <Whisper placement="bottomEnd" trigger="click" speaker={renderPopover}>
      <button
        className="inline-flex items-center justify-center w-10 h-10 rounded-md hover:bg-gray-100"
        title="More actions"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="lucide lucide-ellipsis h-4 w-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          <circle cx="12" cy="12" r="1" />
          <circle cx="19" cy="12" r="1" />
          <circle cx="5" cy="12" r="1" />
        </svg>
      </button>
    </Whisper>
  );
};

export default ActionCellBranch;
